export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/NL-46d1320761f93e6072717f0bacd5f69c.png";